import stylex from '@stylexjs/stylex';
const vars = {
    scale: '1',
};
export const scaleTokens = stylex.defineVars(vars);
